import { Provider } from '@angular/core';
import { ENVIRONMENT, Environment } from '@maia/config';
import { MOCK_FLAG_ON, MockStorageKey } from './mock-scenarios.const';

const readSession = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const applyOverrides = (env: Environment): Environment => {
  const groupAppOverride: boolean = readSession(MockStorageKey.GroupApp) === MOCK_FLAG_ON;
  const productionOverride: boolean = readSession(MockStorageKey.Production) === MOCK_FLAG_ON;
  const devboxOverride: boolean = readSession(MockStorageKey.Devbox) === MOCK_FLAG_ON;
  const production: boolean = productionOverride || env.production;
  return {
    ...env,
    production,
    environmentLabel: productionOverride ? undefined : env.environmentLabel,
    enableDevbox: !production && (devboxOverride || env.enableDevbox),
    featureFlags: {
      ...env.featureFlags,
      groupAppEnabled: groupAppOverride || env.featureFlags.groupAppEnabled,
    },
  };
};

export const mockEnvironmentProvider = (defaultEnv: Environment): Provider => ({
  provide: ENVIRONMENT,
  useFactory: (): Environment => applyOverrides(defaultEnv),
});
